<template>
  <b-modal ref="modal" :title="provider.id ? `Edit Provider ${provider.id}` : 'Create Provider'" lazy>
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>

      <v-form-group :validator="$v.provider.firstName" label="Physician First Name">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="provider.firstName"
                      placeholder="Prescriber First Name" />
      </v-form-group>

      <v-form-group :validator="$v.provider.lastName" label="Physician Last Name">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="provider.lastName"
                      placeholder="Physician Last Name" />
      </v-form-group>

      <v-form-group :validator="$v.provider.physicianNPI" label="Physician NPI">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="provider.physicianNPI"
                      placeholder="Physician NPI" />
      </v-form-group>

      <v-form-group :validator="$v.provider.states" label="States">
        <v-select class="dropdown-wrap"
                  slot-scope="{ attrs, listeners }"
                  v-bind="attrs"
                  v-on="listeners"
                  :options="usaStates.map(state => ({ label: state.name, value: state.name}))"
                  :clearable="false"
                  :filterable="false"
                  :searchable="false"
                  placeholder="States"
                  :reduce="option => option.value"
                  v-model="provider.states"
                  multiple/>
      </v-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn @click="cancel" variant="outline-secondary">Cancel</b-btn>
      <b-btn :loading="loading" variant="success" @click="submit">
        {{ provider.id ? 'Edit' : 'Create' }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { required, numeric } from 'vuelidate/lib/validators';

  import { createNamespacedHelpers } from 'vuex';
  const { mapState, mapActions } = createNamespacedHelpers('provider');

  import { usaStates } from 'typed-usa-states';

  import modalFormMixin from 'mixins/modal-form-mixin';

  import _ from 'lodash';

  export default {
    mixins: [modalFormMixin],


    validations: {
      provider: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        physicianNPI: {
          required,
          numeric
        },
        states: {
          required
        }
      }
    },

    computed: {
      ...mapState(['provider']),

      usaStates() { return usaStates; }
    },

    methods: {
      ...mapActions(['createEditProvider', 'loadProvider']),

      async beforeShow(id) {
        await this.loadProvider(id);

        if (id) {
          let statesArray = []
          this.provider.states.forEach(state => statesArray.push(state.name));
          this.provider.states = statesArray;
        }
      },

      async onSubmit() {
        let newProvider = _.cloneDeep(this.provider);
        let providerSelectedStates = this.provider.states;

        let providerStates = [];
        providerSelectedStates.forEach(state => providerStates.push({ name: state }));
        newProvider.states = providerStates;

        await this.createEditProvider(newProvider);

        this.$emit('onSuccess', this.provider.id)
      },
    }
  }

</script>